var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet20Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    clipPath: "url(#clip0_744_4718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.45996 1.25C1.56152 1.25 0.0224609 2.78906 0.0224609 4.6875V15.3125C0.0224609 17.2109 1.56152 18.75 3.45996 18.75H16.585C18.4834 18.75 20.0225 17.2109 20.0225 15.3125V8.4375C20.0225 6.53906 18.4834 5 16.585 5H4.70996C4.19043 5 3.77246 5.41797 3.77246 5.9375C3.77246 6.45703 4.19043 6.875 4.70996 6.875H16.585C17.4482 6.875 18.1475 7.57422 18.1475 8.4375V15.3125C18.1475 16.1758 17.4482 16.875 16.585 16.875H3.45996C2.59668 16.875 1.89746 16.1758 1.89746 15.3125V4.6875C1.89746 3.82422 2.59668 3.125 3.45996 3.125H17.835C18.3545 3.125 18.7725 2.70703 18.7725 2.1875C18.7725 1.66797 18.3545 1.25 17.835 1.25H3.45996ZM15.0225 13.125C15.354 13.125 15.6719 12.9933 15.9063 12.7589C16.1408 12.5245 16.2725 12.2065 16.2725 11.875C16.2725 11.5435 16.1408 11.2255 15.9063 10.9911C15.6719 10.7567 15.354 10.625 15.0225 10.625C14.6909 10.625 14.373 10.7567 14.1386 10.9911C13.9042 11.2255 13.7725 11.5435 13.7725 11.875C13.7725 12.2065 13.9042 12.5245 14.1386 12.7589C14.373 12.9933 14.6909 13.125 15.0225 13.125Z",
    fill: "#C5C5D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet20Px);
export default __webpack_public_path__ + "static/media/wallet-20px.3cb850b10fe16fb3ea8d744f950eb253.svg";
export { ForwardRef as ReactComponent };